<template>

    <div v-if="!this.reachedMaximumVerificationAttempts">

        <LcForm v-if="!this.showQuiz"
            v-model:application-settings="this.applicationSettings"
            :key="formComponentKey"
            :formData="this.formData"
            :showSkipVerification="this.showSkipVerification"
            @completed.once="this.getQuiz()"
            :showRecaptchaVerification="this.showRecaptchaVerification"
            :shouldEditActiveStep="this.unsuccessfulAttempts > 0"
        />

        <Quiz v-if="!!this.showQuiz"
            v-model:application-settings="this.applicationSettings"
            :quiz="this.quizData"
            :showSkipVerification="this.showSkipVerification"
            @getVerified.once="this.getVerified"
        />
    </div>
    <div v-else>
        <!-- <div class="d-grid gap-2 d-md-flex justify-content-md-end"> -->
        <div class="row mt-2">
            <div class="col-4 offset-4">
                <a v-if="this.showSkipVerification"
                    class="btn btn-lg btn-primary w-100"
                    id="btnSkip"
                    @click.prevent="this.skipVerification()">{{ this.getTranslatedText('__next__', 'buttons') }}</a>
            </div>
        </div>
    </div>

</template>

<script>

    import LcForm from '@/components/form/LcForm.vue';
    import formSteps from '@/form/steps/verification-eid.js';
    import { inject } from 'vue';

    import Quiz from '@/components/verification/Quiz.vue';
    import {formFunctions} from '@/form/helpers/functions.js';

    export default {
        name: 'UserVerification',
        emits: ["update:application-settings","completed"],
        setup(props) {
            // console.log('UserVerification setup');
            const { app, updateApplication, getTranslatedText } = inject('app'); // app is being provided in Application.vue
            return {
                app,
                updateApplication,
                getTranslatedText
            }
        },
        props: {
            applicationSettings: {
                type: Object,
                required: true,
            },
        },
        components: {
            LcForm,
            Quiz
        },
        data: () => {
            const formData = {
                steps: formSteps
            };

            let quizData = {};
            let requestAttempted = false;
            let errors = {};
            let notifications = {};

            let formComponentKey = 0;

            let maxAttemptsBeforeSkip = 2
            let unsuccessfulAttempts = 0;
            let onVerificationStep = false;

            let showRecaptchaVerification = true;

            return {
                formData,
                requestAttempted,
                quizData,
                notifications,
                errors,
                formComponentKey,
                maxAttemptsBeforeSkip,
                unsuccessfulAttempts,
                onVerificationStep,
                showRecaptchaVerification
            };
        },
        mounted() {
            // console.log('Component mounted.')
        },
        computed: {
            showQuiz() {
                return !!this.requestAttempted && Object.keys(this.quizData).length > 0;
            },
            showSkipVerification() {
                return this.unsuccessfulAttempts > 0;
            },
            reachedMaximumVerificationAttempts() {
                return this.unsuccessfulAttempts >= this.maxAttemptsBeforeSkip;
            }
        },
        methods: {
            handleUnsuccessfulRequest(response) {
                this.showRecaptchaVerification = false;
                this.quizData = {};
                this.requestAttempted = false;
                this.notifications = {};
                let errorNotificationMessage = response == 'fail' ? ['Our verification systems are temporarily down. Please try again later.'] : {...response.messages};
                this.unsuccessfulAttempts += 1;
                this.errors = this.reachedMaximumVerificationAttempts ?
                    ['We are unable to locate your credit file with the information you provided. Please try again in a few days. You can still continue with your application by pressing Next'] :
                    errorNotificationMessage;

                if(this.onVerificationStep && this.unsuccessfulAttempts <= this.maxAttemptsBeforeSkip) {
                    this.getQuiz(this.errors);
                }
                else {
                    this.formComponentKey += 1;
                }
            },
            getQuiz(errors) {
                this.applicationSettings.loadingAnimationSeconds = -1;

                let payload = {
                    ...this.app
                };

                this.requestAttempted = true;
                this.errors = !!errors ? errors : {};

                formFunctions.apiGetQuiz(payload).then((response) => {
                    if( response && !!response.status && response.status == 'success' ) {
                        // console.log('getQuiz == success');
                        this.quizData = response;
                        // dont restart the attempts if we are already on the verification step
                        if( !this.onVerificationStep ) {
                            this.unsuccessfulAttempts = 0;
                            this.onVerificationStep = true;
                        }
                    } else {
                        // TODO -- validate errors
                        // console.log('apiGetQuiz != success');
                        this.handleUnsuccessfulRequest(response);
                    }
                }).finally(() => {
                    this.applicationSettings.loadingAnimationSeconds = 0;
                    // console.log('ends');
                });;
            },
            getVerified(payload) {
                // console.log('getVerified() starts');
                // console.log('payload');
                // console.log(payload);
                let isSuccessfulVerification = false;
                this.applicationSettings.loadingAnimationSeconds = -1;
                formFunctions.apiGetVerified(payload).then((response) => {
                    if( response && !!response.status && response.status == 'success' ) {
                        // console.log('apiGetVerified == success');
                        isSuccessfulVerification = true;
                        this.applicationSettings.loadingAnimationSeconds = 0;
                        this.notifications = {...response.messages};
                        this.errors = {};
                    } else {
                        // TODO -- validate errors
                        // console.log('apiGetVerified != success');
                        this.handleUnsuccessfulRequest(response);
                    }
                }).finally(() => {
                    this.applicationSettings.isUserVerified = isSuccessfulVerification;
                    console.log('getVerified() ends');
                });

            },
            skipVerification() {
                this.applicationSettings.notifications.error = {};
                this.applicationSettings.notifications.success = {};
                this.applicationSettings.userWantsVerification = false;
            }

        },
        watch: {
            errors(value, oldValue) {
                this.applicationSettings.notifications.error = value;
            },
            notifications(value, oldValue) {
                this.applicationSettings.notifications.success = value;
            },
        }
    }
</script>
